const ENV = {
    app: import.meta.env.VITE_APP,
    apiHost: import.meta.env.VITE_API_HOST,
    breezeWeb: import.meta.env.VITE_BREEZE_WEB,
    builderIoApiKey: import.meta.env.VITE_BUILDER_IO_API_KEY,
    environment: import.meta.env.VITE_ENVIRONMENT,
    fileHost: import.meta.env.VITE_FILE_HOST,
    googleTagManager: import.meta.env.VITE_GOOGLE_TAG_MANAGER,
    helmHost: import.meta.env.VITE_HELM_HOST,
    hubHost: import.meta.env.VITE_HUB_HOST ?? `https://hub.tithely.dev`,
    messagingPusher: import.meta.env.VITE_MESSAGING_PUSHER,
    messagingHost: import.meta.env.VITE_MESSAGING_HOST ?? `https://messaging.tithely.dev`,
    helmDomain: () => {
        const domain = new URL(import.meta.env.VITE_HELM_HOST)

        return domain ? domain.hostname.split(`.`).slice(1).join(`.`) : ``
    },
    pusherKey: import.meta.env.VITE_PUSHER_KEY ?? `breeze-key`,
    queryCache: import.meta.env.VITE_QUERY_CACHE,
    sentryDSN: import.meta.env.VITE_SENTRY_DSN,
    sentryReplay: import.meta.env.VITE_SENTRY_REPLAY,
    stripeGivingPlatformAccountId: import.meta.env.VITE_STRIPE_GIVING_PLATFORM_ACCOUNT_ID,
    stripePublishableKey: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY,
    tithelyApp: import.meta.env.VITE_TITHELY_APP,
    unlayerProjectId: import.meta.env.VITE_UNLAYER_PROJECT_ID
}

export default ENV
